import styled from "styled-components";
import Colors from "../../../../themes/Colors";

const CartTableSummaryButtonHolder = styled.button`
  display: flex;
  align-items: center;
  gap: 12px;
  height: 32px;
  padding: 0 12px;
  border: none;
  border-radius: 8px;
  background: ${Colors.primary};
  color: ${Colors.onPrimary};
  cursor: pointer;
  font-family: "Poppins", sans-serif;
  white-space: nowrap;
  transition: opacity 0.2s ease-in-out;

  &:hover {
    opacity: 0.9;
  }

  .summarySegment {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 13px;
    font-weight: 600;
  }
  .summaryPrice {
    font-size: 15px;
  }
  .summaryDivider {
    width: 1px;
    align-self: stretch;
    margin: 6px 0;
    background: rgba(255, 255, 255, 0.4);
  }
  .summaryScreenIcon {
    height: 16px;
    width: 16px;
  }
    
  .summaryExtra {
    display: contents;
  }
  @media only screen and (max-width: 1200px) {
    .summaryExtra {
      display: none;
    }
  }
`;

export default CartTableSummaryButtonHolder;
